export { default } from "./TableHeaderCell";
